import React from 'react';
import PropTypes from 'prop-types';

const AiTag = ({
	index,
	label,
}) => (
	<div className="ignite-ai__tag" key={index}>{label}</div>
);

export default AiTag;

AiTag.propTypes = {
	index: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
};
